const $doc = $(document);

$doc.on('change', '.js-select-relocate select', function() {
  const $selectedOption = $(this).find('option:selected');
  const optionVal = $selectedOption.val();
  if (optionVal != '') {
    window.location.href = optionVal;
  };
});



// WEBPACK FOOTER //
// ../assets/js/select-relocate.js